import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";



export var AdminAddDepartmentRes;
export const AdminAddDepartmentTodo = createAsyncThunk('adminAdminAddDepartment', async (data) => {
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'admin/department_admin',
            data: {
                "name": data?.department,
                "company_id": localStorage.getItem('companyId'),
                "status": data?.status,
                "added_by": localStorage.getItem('user_id'),
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + localStorage.getItem('user_token') }
        })
        return AdminAddDepartmentRes = res.data

    } catch (error) {
        return AdminAddDepartmentRes = error.response.data
    }
})